import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, A11y, Autoplay, EffectFade } from 'swiper';
import { Link, useHistory, Redirect } from 'react-router-dom';

import Input from '../../components/Input';
import Button from '../../components/Button';
import api from '../../services/api';
import { login, isAuthenticated } from '../../services/auth';
import { useForm } from '../../hooks/useForm';

import ImageSlide1 from '../../assets/register-slide-1.jpg';
import ImageSlide2 from '../../assets/register-slide-2.jpg';
import ImageSlide3 from '../../assets/register-slide-3.jpg';
import ImageSlide4 from '../../assets/register-slide-4.jpg';
import ImageSlide5 from '../../assets/register-slide-5.jpg';
import ImageLogoNooio from '../../assets/logo-nooio-black.svg';

import { LoginContainer } from './styles';
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([Navigation, Pagination, EffectFade, A11y, Autoplay]);

interface LoginData {
  email: string;
  password: string;
}

function Login() {
  const history = useHistory();
  const { getEntriesByEvent } = useForm();

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault();

    const entries = getEntriesByEvent<LoginData>(e);
    if (!entries) return;

    const data = entries;

    const response = await api.post('/auth/login', data)
      .then(response => response && response.data.result)
      .catch(error => handleMessage(400, 'Erro', 'Houve um erro inesperado, verifique os dados e tente novamente'))
    ;

    if (!response || !response.token || !response.refresh_token.user_id) return handleMessage(500, 'Error', 'Houve um erro no servidor, tente novamente mais tarde!');

    handleMessage(200, 'Sucesso', 'Sua conta foi acessada!');

    login({
      token: response.token,
      user_id: response.refresh_token.user_id
    });

    setTimeout(() => {
      history.push('/dashboard');
    }, 2000);
  }

  function handleMessage(code: number, title: string, error: string) {
    const messages = document.querySelector('.messages-container');
    const message = document.createElement('div');

    // Verify if message already exist
    const messagesList = Array.from(document.querySelectorAll('.status-message'));
    const alreadyExist = messagesList.find(messageItem => messageItem.id === `code-${code}`);
    if (alreadyExist) return;

    message.className = 'status-message';
    message.classList.add(code === 200 ? 'success' : 'error');
    message.id = 'code-' + code;
    message.innerHTML = `
      <i class="fal fa-times"></i>

      <div class="text">
        <strong>${title}</strong>
        <span>${error}</span>
      </div>
    `;
    message.style.animation = 'enterAnimation .5s ease-in-out forwards';

    messages?.appendChild(message);
    document.querySelector(`#code-${code} i`)?.addEventListener('click', remove);

    function remove() {
      message.style.animation = 'outAnimation .5s ease-in-out forwards';

      setTimeout(() => {
        message.remove();
      }, 500);
    }

    setTimeout(remove, 10000);
  }

  function handleBack() {
    history.goBack();
  }

  return isAuthenticated() ? <Redirect to={{ pathname: "/dashboard" }} /> : (
    <LoginContainer>
      <header>
        <span onClick={handleBack}>
          <i className="far fa-arrow-left"></i>
          <span>Voltar</span>
        </span>

        <Link to="/register">Cadastre-se</Link>
      </header>

      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        effect="fade"
        navigation
        loop
        pagination={{ clickable: true }}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
      >
        
        <SwiperSlide>
          <img src={ImageSlide2} alt="slide 2" />
          <div className="shadow"></div>
        </SwiperSlide>

        <SwiperSlide>
          <img src={ImageSlide1} alt="slide 1" />
          <div className="shadow"></div>
        </SwiperSlide>
        
        <SwiperSlide>
          <img src={ImageSlide3} alt="slide 3" />
          <div className="shadow"></div>
        </SwiperSlide>

        <SwiperSlide>
          <img src={ImageSlide4} alt="slide 4" />
          <div className="shadow"></div>
        </SwiperSlide>

        <SwiperSlide>
          <img src={ImageSlide5} alt="slide 5" />
          <div className="shadow"></div>
        </SwiperSlide>

      </Swiper>

      <div className="login-content">
        <div className="form-container">
          <div className="heading">
            <img src={ImageLogoNooio} alt="Nooio" />
            <h1>Entrar</h1>
          </div>

          <form id="login-form" onSubmit={handleLogin}>
            <Input name="email" label="E-mail" />

            <Input type="password" name="password" label="Senha" />

            <Button type="submit">Acessar conta</Button>
          </form>

          <div className="has-account">
            <div className="or"></div>

            <Link to="/register">Não tem conta ainda? <strong>Cadastre-se</strong></Link>
          </div>
        </div>
      </div>

      <div className="messages-container"></div>
    </LoginContainer>
  );
};

export default Login;
